import * as React from 'react';
import { useMemo } from 'react';

import Select from '@repo/editor/src/components/SelectNew/Select';
import { withEventScope } from '@repo/event-processor';
import { IconButton } from '@repo/ui/components/Buttons';
import ArrowRightIcon from '@repo/ui/components/Icon/ArrowRightIcon';
import { themeStyle } from '@repo/ui/theming';
import times from 'lodash/times';

import { FloatingPanel } from 'components/BackgroundReplacer/Pagination/styles';
import { PaginationProps } from 'components/BackgroundReplacer/Pagination/types';

const Pagination: React.FC<PaginationProps> = ({
  current,
  total,
  onSelect,
}) => {
  const floatingButtonTheme = {
    color: themeStyle.varInkMedium,
    activeColor: themeStyle.varInkMain,
    activeDefaultColor: themeStyle.varInkMain,
  };

  const options = useMemo(
    () =>
      times(total, (i) => ({
        id: i,
        label: `${i + 1} / ${total}`,
      })),
    [total]
  );

  return (
    <FloatingPanel>
      <IconButton
        ariaLabel="Previous Page"
        disabled={current === 0}
        height="20px"
        icon={ArrowRightIcon}
        name="paginationPreviousButton"
        style={{ transform: 'rotate(180deg)' }}
        theme={floatingButtonTheme}
        tooltipText="Previous Page"
        onClick={(): void => onSelect(current - 1)}
      />
      <Select
        compact
        noExpandIcon
        small
        activeOption={options.find((option) => option.id === current)}
        customStyles={{
          height: '24px',
          noBorder: true,
          background: themeStyle.varInkSuperLight,
        }}
        options={options}
        onSelect={(option): void => onSelect(option.id as number)}
      />
      <IconButton
        ariaLabel="Next Page"
        disabled={current === total - 1}
        height="20px"
        icon={ArrowRightIcon}
        name="nextPageButton"
        theme={floatingButtonTheme}
        tooltipText="Next Page"
        onClick={(): void => onSelect(current + 1)}
      />
    </FloatingPanel>
  );
};

export default withEventScope(Pagination, {
  module: 'backgroundReplacerPagination',
});
